module.exports = __webpack_public_path__ + "img/creek_state_park.png";